import React, { useContext } from "react";
const AppConfigContext = /*#__PURE__*/React.createContext(null);
export const AppConfigProvider = ({
  config,
  children
}) => {
  return /*#__PURE__*/React.createElement(AppConfigContext.Provider, {
    value: config
  }, children);
};
export const useAppConfig = () => {
  const appConfig = useContext(AppConfigContext);
  if (!appConfig) {
    throw new Error("appConfig is missing. Remember to wrap your MFE with AppConfigProvider");
  }
  return appConfig;
};